import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <nav className={`fixed w-full z-50 px-6 py-4 bg-white/80 backdrop-blur-lg border-b border-[#E9D5FF]/20 ${isScrolled ? "shadow-sm" : ""}`}>
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center gap-x-2">
          
        </Link>

        {/* Navigation Button - Always Visible */}
        <Link to="/">
          <Button className="rounded-full px-6 text-neutral-50 bg-purple-600 hover:bg-purple-500">Visita il sito</Button>
        </Link>
      </div>
    </nav>;
};
export default Navbar;